import React, {useEffect, useState} from 'react';
import Select from 'react-select';
import {
  useLazyCorporateDetailsQuery,
  useLazyGetUsersRolesQuery,
  useUpdateUserRoleMutation,
} from '../../../store/builder/inspections.api';
import CustomLoader from '../../CustomLoader/CustomLoader';
import {toast} from 'react-toastify';
import {useSelector} from 'react-redux';
import {useTranslation} from '../../../hooks/useTranslation';
const UpdateRole = ({
  setUpdateRoleModal,
  currentUser,
  agencyData,
  getUsers,
  trigerGetUsers,
  setTrigerGetUsers,
  open
}) => {
  const [role, setRole] = useState();
  const {t} = useTranslation();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const [chosenAgency, setChosenAgency] = useState({});
  const [chosenRegion, setChosenRegion] = useState({});

  const [updateUserRole, {isLoading: updateUserRoleIsLoading}] =
    useUpdateUserRoleMutation();

  const [getUserRoles, {data: userRolesData, isLoading: userRolesIsLoading}] =
    useLazyGetUsersRolesQuery();

  const [getCorporate, {data: corporateData, isLoading: isLoadingCorporate}] = useLazyCorporateDetailsQuery();

  useEffect(() => {
    if (userRolesData && currentUser) {
      const matchedRole = userRolesData?.find(
        role => currentUser?.role_title === role?.name,
      );
      setRole({
        value: matchedRole?.id,
        label: matchedRole?.name,
      });
    }

    const matchedAgency = agencyData?.find(
      agency => currentUser?.agency_title === agency?.title,
    );

    if (currentUser && matchedAgency) {
      setChosenAgency({
        value: matchedAgency?.id,
        label: matchedAgency?.title,
      });
    }

    const matchedRegion = corporateData?.regions?.find(
      reg => currentUser?.region_id === reg?.id,
    );

    if (currentUser && matchedRegion) {
      setChosenRegion({
        value: matchedRegion?.id,
        label: matchedRegion?.name,
      });
    }
  }, [currentUser, userRolesData, corporateData?.regions]);

  useEffect(() => {
    getUserRoles();
  }, []);

  useEffect(() => {
    if (currentUser?.corporate_id) {
      getCorporate(currentUser.corporate_id);
    }
  }, [currentUser, userRolesData, open]);

  const getAvailableRoles = () => {
    let neededRoles = [
      'linesman',
      'inspector',
      'fuel_clerk',
      'management',
      'read_only',
      'corporate',
      'regional_corporate',
    ];

    if (!userInfo?.is_admin) {
      neededRoles.push('admin');
    }

    return userRolesData?.filter(role => neededRoles.includes(role.key));
  };

  const handleCancel = () => {
    setUpdateRoleModal(false);
  };

  const handleConfirm = () => {
    const body = {
      role_id: role?.value,
    };

    if (chosenAgency.value) {
      body.agency_id = chosenAgency.value;
    }

    if (chosenRegion.value) {
      body.region_id = chosenRegion.value;
    }

    updateUserRole({
      id: currentUser?.id,
      body,
    }).unwrap()
      .then(data => {
        getUsers();
        setTrigerGetUsers(!trigerGetUsers);
        setUpdateRoleModal(false);
        toast.success(data?.data?.message);
      })
      .catch(data => {
        getUsers();
        setTrigerGetUsers(!trigerGetUsers);
        setUpdateRoleModal(false);
        toast.error(data?.data?.message);
      });
  };

  return (
    <form className='modal'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>{t('managementRow.modals.updateRole')}</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={handleCancel}
          />
        </div>
        <div className='modal__content-body user' style={{paddingBottom: 0}}>
          <div
            className='modal__content-body_warningText'
            style={{marginBottom: 20}}
          >
            {t('managementRow.modals.updateRoleFor')}:{' '}
            <span>
              {currentUser?.name} - {currentUser?.email}
            </span>
          </div>

          {!currentUser.corporate_id && corporateData?.details?.title && (
            <div
              className='modal__content-body_warningText'
              style={{marginBottom: 20}}
            >
              {t('managementRow.modals.fbo')}: <span>{corporateData?.details?.title}</span>
            </div>
          )}
          {currentUser.corporate_id && corporateData?.details?.title && (
            <div
              className='modal__content-body_warningText'
              style={{marginBottom: 20}}
            >
              {t('managementRow.modals.corporate')}: <span>{corporateData?.details?.title}</span>
            </div>
          )}

          <span className='customSelect__label'>{t('managementRow.labels.role')}</span>
          <Select
            isDisabled={userRolesIsLoading || isLoadingCorporate}
            options={getAvailableRoles()?.map(role => ({
              value: role.id,
              label: role.name,
            }))}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                height: 42,
                backgroundColor: '#F4F5F6',
                marginTop: 8,
                marginBottom: 8,
                textTransform: 'capitalize',
              }),
              menuPortal: base => ({...base, zIndex: 9999}),
            }}
            menuPortalTarget={document.body}
            value={role}
            onChange={e => {
              setRole(e);
              setChosenAgency({});
              setChosenRegion({});
            }}
          />
        </div>
        {role?.value !== 1 && role?.value !== 9 && role?.value !== 8 && (
          <div
            className='modal__content-body user'
            style={{paddingBottom: 0, paddingTop: 0}}
          >
            <div className='customSelect'>
              <span className='customSelect__label'>
                { !currentUser?.corporate_id ? t('managementRow.labels.fboCorporateIdNotFound') : t('managementRow.labels.fbo')}
                {currentUser?.corporate_id && <span style={{color: 'red'}}> *</span>}
              </span>
              <Select
                isDisabled={!currentUser?.corporate_id || isLoadingCorporate}
                options={corporateData?.corporate_agencies?.map(role => ({
                  value: role.id,
                  label: role.title,
                }))}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                    borderRadius: 8,
                    height: 42,
                    backgroundColor: '#F4F5F6',
                    marginTop: 8,
                  }),
                  menuPortal: base => ({...base, zIndex: 9999}),
                }}
                name={'agency_ids'}
                value={chosenAgency}
                onChange={e => setChosenAgency(e)}
                menuPosition={'absolute'}
                menuPortalTarget={document.body}
              />
              {currentUser?.corporate_id && !chosenAgency?.value && (
                <span style={{color: 'red', fontSize: 12, marginTop: 4}}> {t('managementRow.labels.fboCorporateIdNotFound')}</span>
              )}
            </div>
          </div>
        )}
        {role?.value === 9 && (
          <div className='modal__content-body user' style={{paddingTop: 0}}>
            <div className='customSelect'>
              <span className='customSelect__label'>{t('managementRow.labels.region')}</span>
              <Select
                isDisabled={isLoadingCorporate}
                options={corporateData?.regions?.map(reg => ({
                  value: reg.id,
                  label: reg.name,
                }))}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                    borderRadius: 8,
                    height: 42,
                    backgroundColor: '#F4F5F6',
                    marginTop: 8,
                  }),
                  menuPortal: base => ({...base, zIndex: 9999}),
                }}
                name={'agency_ids'}
                value={chosenRegion}
                onChange={e => setChosenRegion(e)}
                menuPosition={'absolute'}
                menuPortalTarget={document.body}
              />
            </div>
          </div>
        )}
        <div className='modal__content-bottom'>
          <button type='button' className='close' onClick={handleCancel}>
            {t('managementRow.modals.cancel')}
          </button>
          <button
            type='button'
            className='save'
            onClick={handleConfirm}
            style={{
              opacity: !role?.value || 
              updateUserRoleIsLoading ||
              (role?.value !== 1 && role?.value !== 9 && role?.value !== 8 && currentUser?.corporate_id && !chosenAgency?.value) ? 0.5 : 1,
            }}
            disabled={
              !role?.value || 
              updateUserRoleIsLoading ||
              (role?.value !== 1 && role?.value !== 9 && role?.value !== 8 && currentUser?.corporate_id && !chosenAgency?.value)
            }
          >
            <div>
              {updateUserRoleIsLoading ? <CustomLoader width={10} /> : t('managementRow.modals.update')}
            </div>
          </button>
        </div>
      </div>
      <div className='modal__bg'></div>
    </form>
  );
};

export default UpdateRole;
